import Lottie from 'lottie-react';

import lottieMedications from '../jsons/medications.json';

const LottieMedications = props => {
  return <Lottie animationData={lottieMedications} loop={false} {...props} />;
};

export default LottieMedications;
